// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vJagr","title":"styles_title__1dJmY","value":"styles_value__gdY6W"};